import mailTemplates from 'plugins/i18n/mailTemplates.en.ts'

export default {
	management: {
		sync: {
			dataUpdate: 'Data update',
		},
		analysis: {
			rate: 'Rate',
			currentRateInfo:
				'Your current plan includes {storage} of storage and {units} units. If, after a data update, you use more than 80 or 90% of your plan, you will receive a notification at your registered email address. If you reach 100% of your plan, an additional 50GB will automatically be added to your quota or the next unit package will be activated.',
			availablePercent: 'Available (%)',
			usedPercent: 'Used (%)',
		},
		user: {
			usage: 'Usage',
			accessOverview:
				'Graphical analysis of accesses in the defined period. Please note that only unique logins are counted. This means that repeated visits to your page with an already completed login will not be counted.',
			lastSevenDays: 'Last 7 days',
			lastThirtyDays: 'Last 30 days',
			currentMonth: 'Current month',
			lastMonth: 'Last month',
			currentYear: 'Current year',
			lastYear: 'Last year',
		},
		documenttypes: {
			documentTypeDistribution:
				'Graphical analysis of the distribution of your documents across your document types',
			// Export
			export: 'Export',
			markForExport: 'Mark',
			unmarkForExport: 'Unmark',
			markForExportTitle: 'Mark Document Types for Export',
			unmarkForExportTitle: 'Unmark Document Types from Export',
			markForExportDescription:
				'You are about to mark {count} document type for export from Karthago. | You are about to mark {count} document types for export from Karthago.',
			unmarkForExportDescription:
				'You are about to unmark {count} document type from export. | You are about to unmark {count} document types from export.',
			markForExportDisclaimer:
				'Marking document types for export will upload folders from Karthago document management system. Ensure all settings are correct before confirming.',
			unmarkForExportDisclaimer:
				'WARNING: Unmarking document types from export will remove the corresponding documents from the Aaremo-Portal.',
			whatHappensMarkItem1: 'Document types will be flagged as "proposed for export"',
			whatHappensMarkItem2: 'Corresponding files will be uploaded into Aaremo',
			whatHappensMarkItem3: 'Documents can be organized into these folder structures in Karthago',
			whatHappensUnmarkItem1: 'Document types will be removed from the export list',
			whatHappensUnmarkItem2: 'Corresponding folders will be removed from Aaremo',
			whatHappensUnmarkItem3: 'Documents in these folders may need to be reorganized',
			confirmMark: 'Confirm & Mark for Export',
			confirmUnmark: 'Confirm & Unmark',
			exportStatusUpdateError: 'Failed to update export status. Please try again.',
			confirmMarkForExport:
				'Do you want to mark {count} document type for export? | Do you want to mark {count} document types for export?',
			confirmUnmarkForExport:
				'Do you want to unmark {count} document type from export? | Do you want to unmark {count} document types from export?',
			exportModalTitle: 'Document Types Export',
			selectedDocumentTypesExportMessage:
				'{count} document type selected | {count} document types selected',
			exportModalDescription:
				'Mark or unmark the selected document types for export. You can refine your selection below.',
			currentExportStatus: 'Current Export Status',
			markedForExport: 'Marked for Export',
			notMarkedForExport: 'Not Marked for Export',
			// Cutoff (per document type document age limit)
			cutoffModalTitle: 'Set document age cutoff',
			cutoffModalDescription:
				'Set a maximum age (in years) and/or a fixed cutoff date per document type. When a cutoff date is set, it overrides the max age years value.',
			cutoffModalUploadHint:
				'Documents in these folders will be picked up and uploaded to Aaremo from the configured date onwards — older documents are skipped.',
			cutoffMaxAgeYearsLabel: 'Max age (years, 1–50)',
			cutoffDateLabel: 'Cutoff date (optional)',
			cutoffApply: 'Apply to selection',
			cutoffNoValue: 'Please provide a max age or a cutoff date.',
			cutoffUpdateError:
				'Failed to update document type cutoffs. Please try again.',
			cutoffApplyButtonLabel: 'Set cutoff',
			cutoffMaxAgeYearsPreview: 'Equals cutoff date {date} (Jan 1st)',
			cutoffDateOverridesYears:
				'A cutoff date overrides the max-age value when set.',
			cutoffMixedValuesHint:
				'Selection contains different values — leaving blank keeps each row\'s current setting.',
			cutoffModeMaxAge: 'By age (rolling)',
			cutoffModeMaxAgeHint: 'Today minus N years, advances over time.',
			cutoffModeFixedDate: 'Fixed cutoff date',
			cutoffModeFixedDateHint: 'A specific date that does not move.',
			cutoffCurrentMaxAge: 'current: max {years} years',
			cutoffCurrentFixedDate: 'current: cutoff {date}',
			cutoffCurrentNone: 'current: no cutoff',
			displayNameLabel: 'Display name (optional)',
			displayNameHint:
				'When set, this name is shown in the UI instead of the original name from the source system. Leave empty to keep the original name.',
			displayNameOriginalLabel: 'Original name',
			// Bulk Edit (unified mask, replaces Export + Cutoff + Sending Settings)
			bulkEdit: 'Bulk Edit',
			bulkEditModalTitle:
				'Bulk Edit — {count} document type | Bulk Edit — {count} document types',
			bulkEditIntroTitle: 'How bulk-edit works',
			bulkEditApplyHint:
				'Tick the checkbox left of a field to apply its value to every selected document type. Fields without a tick stay untouched.',
			bulkEditMixedHintExample:
				'= mixed values across the selection (e.g. 13 of 22 document types have "Notify" enabled, 9 don\'t).',
			bulkEditSectionExport: 'Export & Cutoff Date',
			bulkEditSectionExportHelp:
				'Controls which document types are exported to Aaremo and from which date documents start being captured. Max age and fixed cutoff date are mutually exclusive.',
			bulkEditSectionDispatch: 'Dispatch & Notifications',
			bulkEditSectionDispatchHelp:
				'Push notifications for new documents in the mobile app. "Weeks" limits notifications to documents younger than the configured number of weeks.',
			cutoffSectionHelp:
				'From which date documents of this type are transferred to Aaremo. Either pick a rolling max age (e.g. 6 years = from Jan 1st of this year minus 6) or a fixed date. Documents older than the cutoff are skipped.',
			bulkEditApply: 'apply to selection',
			bulkEditCutoffMutex:
				'Max age and fixed cutoff date are mutually exclusive — only one can be applied at a time.',
			bulkEditUpdateError:
				'Failed to bulk-update document types. Please try again.',
		},
		buildingVisibility: {
			subtitle: 'Manage hidden buildings (Karthago)',
			onlyKarthago: 'This feature is only available for Karthago clients.',
			introLead:
				'Here you exclusively manage buildings that are {highlight}. Buildings marked for export remain fully synchronized and do not appear here.',
			introHighlight: 'not released for Aaremo export',
			introCascade:
				'Hidden buildings disappear from the property list and all building selection components. Existing reports, tasks, persons, notes and document checks remain unaffected.',
			save: 'Save',
			savePending: 'Save ({count})',
			filterAll: 'All ({count})',
			filterVisible: 'Visible ({count})',
			filterHidden: 'Hidden ({count})',
			search: 'Search',
			show: 'Show',
			showCount: 'Show ({count})',
			hide: 'Hide',
			hideCount: 'Hide ({count})',
			colFirma: 'Company',
			colObjNr: 'Obj. No.',
			colAddress: 'Address',
			colStatus: 'Status',
			statusHidden: 'Hidden',
			statusVisible: 'Visible',
			savedSuccess: 'Visibility saved',
		},
		roles: {
			buildingAccess: 'Access to the building',
			documenttypeAccess: 'Access to all document types',
			documenttypeAccessIndividual: 'Access to individual document types',
			roleAccess: 'Access to all person roles',
			roleAccessIndividual: 'Access to individual person roles',
			invoiceAccess: 'Access to invoices',
			invoiceAccessAssigned: 'Access to assigned invoices',
			journalAccountsAccess: 'Access to journal accounts',
			personalAccounts: 'Personal accounts',
			personalAccountsAccess: 'Access to personal accounts',
			unitAccess: 'Access to the unit',
			addressLinkRequired: 'Address link required',
			cisTypeAccess: 'Access to all C.I.S. types',
			cisTypeAccessIndividual: 'Access to individual C.I.S. types',
			taskTypeAccess: 'Access to all task types',
			taskTypeAccessIndividual: 'Access to individual task types',
			visibility: 'Visibility / Public',
			rolesVisible: 'Visible to all person roles',
			roleVisible: 'Visible to individual person role',
			copySettings: 'Copy the settings to apply them to another person role',
			unlimitedAccess: 'unlimited Access',
			fromStartofRole: 'from start of PF',
			faqAccess: 'Access to the FAQs',
		},
		settings: {
			list: 'List',
			tiles: 'Tiles',
			group_tiles: 'Group tiles',
			group_list: 'Group list',
			module: 'Modules',
			functions: 'Functions',
			functionsInfo: 'The following functions can be enabled for users.',
			dataUpdateRequests: 'Data Update Requests',
			reportAutoAssignment:
				'Automatic Assignment of Reports to Property Managers',
			programAreas: 'Application Areas',
			programAreasInfo:
				'The following application areas can be enabled for users. The corresponding data will be imported from HausPerfekt and, if applicable, also synchronized back.',
			meterReadingManagement: 'Meter Readings Management',
			journalAccounts: 'Journal Accounts',
			personalAccounts: 'Personal accounts',
			options: 'Options',
			hidePropertyInformation: 'Hide property information',
			defaultViews: 'Default views',
			theDocuments: 'of the documents',
			thePersons: 'of the persons',
			theBuildings: 'of the buildings',
			colors: 'Colors',
			welcomeText: 'Welcome text',
			background: 'Background',
			navigation: 'Navigation',
			primary: 'Primary',
			secondary: 'Secondary',
			objects: 'Buildings',
			newDocuments: 'New documents',
			reportsDeadlinesOverview: 'Reports deadline overview',
			selectLogo: 'Select Logo',
			trackleanIntegration: 'Tracklean Integration',
			trackleanDomain: 'Tracklean Domain',
			trackleanApiKey: 'Tracklean API Key',
			protocolSavedUnderDocumentType:
				'The protocol is stored under the specified document type',
			loginGreetingTextInfo:
				'This text is displayed to every user at login (optionally, the greeting text can also be shown on the dashboard)',
			emailImportSend: 'Import / Sending of Emails',
			templateGlobalSettingsInfo:
				'Settings for sender name, sender address, logo, and greeting apply to all templates, unless a template has its own individual setting.',
			notificationSending: 'Send Notifications',
			controlSendingPerDocumentType:
				'You can also control the sending per {link}.',
			autoSendWelcomeEmailsCredentials:
				'Automatic sending of welcome emails / credentials',
			statusEmailSending: 'Send Status Emails',
			// AAR-1116 — digest interval for comment notifications
			commentDigest: 'Bundle comment notifications',
			commentDigestInfo:
				'Notifications about new comments are collected and sent in a single email at the selected interval.',
			commentDigestImmediate: 'Immediately',
			commentDigestMinutes: '{minutes} minutes',
			commentDigestHourly: 'Hourly',
			commentDigestDaily: 'Daily',
			senderName: 'Sender Name',
			replyAddress: 'Reply Address',
			selectEmailLogo: 'Select Email Logo',
			greeting: 'Greeting',
			mailTemplates: mailTemplates,
			additionalRecipient: 'Additional recipient',
			emailBody: 'Letter',
			preview: 'Preview',
			mailPreview: 'Email Preview',
			reason: 'Reason',
			sendingSettings: 'Sending Settings',
			documentTypeEdit: 'Edit document type {acronym}',
			updateDocumentTypeDispatch: 'Update dispatch of document types',
			sortOrder: 'Sort order',
			notificationSettings: 'Notification settings',
			notOlderThanWeeks: 'Not older than specified weeks',
			abbreviation: 'Abbreviation',
			quantity: 'Quantity',
			sending: 'Delivery',
			confirmDeletion:
				'Please confirm that the following {count} {name} will be deleted.',
			templateName: 'Template Name',
			standardTexts: 'Standard Texts',
			initialInspection: 'Initial Inspection',
			finalInspection: 'Final Inspection',
			gracePeriod: 'Grace period',
			createReportType: 'Create report type',
			createEntry: 'Create entry',
			createSubcategory:
				'Please make sure to create a subcategory. As long as no subcategory exists, it is not allowed to create a report with this category.',
			entry: '@:common.entry',
			optionalDescription: '(optional) Description',
			images: 'Images',
			imagesTip: 'With this setting, attaching an image becomes mandatory',
			requireImage: 'Should at least one image be attached?',
			location: 'Location',
			locationTip: 'With this setting, the location field becomes mandatory',
			locationDescription: 'Should a location description be mandatory?',
			personRoleUsage: 'The person role to be used for further processing',
			processStep: 'Process step',
		},
	},
}
